var _defs, _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    zoomAndPan: "magnify",
    viewBox: "0 0 900 899.99999",
    height: 1200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "e709482593"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 271.398438 263.003906 L 636.648438 263.003906 L 636.648438 628.253906 L 271.398438 628.253906 Z M 271.398438 263.003906 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -90,
    width: 1080,
    y: -89.999999,
    height: 1079.999988,
    fillOpacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -90,
    width: 1080,
    y: -89.999999,
    height: 1079.999988,
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e709482593)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#99b83c",
    d: "M 454.140625 263.09375 C 555.117188 263.09375 636.972656 344.949219 636.972656 445.921875 C 636.972656 546.894531 555.117188 628.753906 454.140625 628.753906 C 353.167969 628.753906 271.3125 546.894531 271.3125 445.921875 C 271.3125 344.949219 353.167969 263.09375 454.140625 263.09375 Z M 454.140625 335.144531 C 468 335.144531 479.253906 346.382812 479.253906 360.257812 C 479.253906 374.132812 468.015625 385.371094 454.140625 385.371094 C 440.285156 385.371094 429.027344 374.132812 429.027344 360.257812 C 429.027344 346.398438 440.265625 335.144531 454.140625 335.144531 Z M 431.316406 404.15625 L 476.980469 404.15625 L 476.980469 520.296875 L 495.242188 520.296875 L 495.242188 556.683594 L 413.074219 556.683594 L 413.074219 520.296875 L 431.316406 520.296875 L 431.316406 423.222656 L 413.074219 423.222656 L 413.074219 404.15625 Z M 454.140625 280.726562 C 362.917969 280.726562 288.960938 354.664062 288.960938 445.90625 C 288.960938 537.144531 362.902344 611.085938 454.140625 611.085938 C 545.382812 611.085938 619.320312 537.128906 619.320312 445.90625 C 619.320312 354.664062 545.382812 280.726562 454.140625 280.726562 Z M 454.140625 280.726562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.64d68a13505328ba326448425cc4934f.svg";
export { ForwardRef as ReactComponent };